// extracted by mini-css-extract-plugin
module.exports = {"progress":"Loading_progress__6sVGZ"};